/**
 * 选择器上下文 - 管理机场和供应商选择状态
 * 
 * 职责：
 * - 只管理那些驱动数据获取的用户选择项，如 activeAirports 和 selectedSupplier
 * - 提供选择相关的操作方法
 * - 与业务数据状态分离
 */

import React, { createContext, useContext } from 'react';
import { useSelectionManager } from '../hooks/useSelectionManager';
import { extractAirportsFromFlights } from '../utils';

// 创建Context
const SelectionContext = createContext();

/**
 * 选择器Provider组件
 */
export const SelectionProvider = ({ children, initialFlights, transactionType }) => {
  // 从航班中提取可用机场
  const availableAirports = extractAirportsFromFlights(initialFlights || []);
  
  // 使用选择管理器Hook
  const selectionManager = useSelectionManager(availableAirports, transactionType);

  const contextValue = {
    // 可用选项
    availableAirports,
    
    // 选择管理器的所有状态和方法
    ...selectionManager
  };

  return (
    <SelectionContext.Provider value={contextValue}>
      {children}
    </SelectionContext.Provider>
  );
};

/**
 * Hook for using selection context
 */
export const useSelectionContext = () => {
  const context = useContext(SelectionContext);
  if (!context) {
    throw new Error('useSelectionContext must be used within a SelectionProvider');
  }
  return context;
};

export default SelectionContext;
